import { render, staticRenderFns } from "./RelicPedestal.vue?vue&type=template&id=57c4741f&scoped=true"
import script from "./RelicPedestal.vue?vue&type=script&lang=js"
export * from "./RelicPedestal.vue?vue&type=script&lang=js"
import style0 from "./RelicPedestal.vue?vue&type=style&index=0&id=57c4741f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c4741f",
  null
  
)

export default component.exports